class NResponsiveSlider extends HTMLElement {
  constructor() {
    super()
    this.blazeInstance = null
    this.isMobile = window.innerWidth <= 768
    this.resizeObserver = null
    this.disableScroll = this.hasAttribute('disable-scroll')
    this.mobileSlider = this.hasAttribute('data-mobile-slider')
    this.currentSlideIndex = 0 // Mevcut slide index'ini takip et
    this.userInteracted = false
    this.config = {
      all: {
        slidesPerView: 3
      }
    }
    this.container = this.querySelector('.blaze-slider')

    // Slider elementlerini seç
    this.prevButton = this.container.querySelector('.blaze-prev')
    this.nextButton = this.container.querySelector('.blaze-next')
  }

  connectedCallback() {
    this.loadConfig()
    this.init()
    this.setupResizeObserver()
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  disconnectedCallback() {
    this.destroySlider()
    window.removeEventListener('resize', this.handleResize.bind(this))
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  loadConfig() {
    const configScript = this.querySelector('script[type="application/json"]')
    if (configScript) {
      try {
        const userConfig = JSON.parse(configScript.textContent)
        this.config = { ...this.config, ...userConfig }
        configScript.remove() // Config'i okuduktan sonra script tag'ini kaldır
      } catch (error) {
        console.error('Config parsing error:', error)
      }
    }
  }

  init() {
    if (!this.isMobile || this.disableScroll || this.mobileSlider) {
      this.initBlazeSlider()
    }
  }

  initBlazeSlider() {
    this.blazeInstance = new BlazeSlider(this.container, this.config)

    // Eğer loop özelliği açıksa, okları her zaman göster
    if (this.config.loop && this.prevButton && this.nextButton) {
      this.prevButton.style.visibility = 'visible'
      this.nextButton.style.visibility = 'visible'
    } else if (this.prevButton && this.nextButton) {
      // Loop özelliği kapalıysa, başlangıçta sol oku gizle (ilk slayttayız)
      this.prevButton.style.visibility = 'hidden'
      this.blazeInstance.onSlide(this.handleChange.bind(this))
    }

    // Slider hazır olduktan sonra thumbnail setup'ı yap
    this.setupThumbnailClicks()

    // Pagination setup'ı yap
    this.setupPaginationScroll()
  }

  destroySlider() {
    if (!this.disableScroll && !this.mobileSlider) this.blazeInstance.destroy()
  }

  handleChange(pageIndex, firstVisibleSlideIndex, lastVisibleSlideIndex) {
    // Mevcut slide index'ini güncelle
    this.currentSlideIndex = firstVisibleSlideIndex

    // Slide sayısını al
    const slideCount = this.container.querySelectorAll('.blaze-track > *').length
    // İlk slide'da sol oku gizle, değilse göster
    if (firstVisibleSlideIndex === 0) {
      this.prevButton.style.visibility = 'hidden'
    } else {
      this.prevButton.style.visibility = 'visible'
    }

    // Son slide'da sağ oku gizle, değilse göster
    if (lastVisibleSlideIndex === slideCount - 1) {
      this.nextButton.style.visibility = 'hidden'
    } else {
      this.nextButton.style.visibility = 'visible'
    }

    if (this.userInteracted) {
      this.updateActiveThumbnail(firstVisibleSlideIndex)
    }

    // Pagination scroll'u güncelle
    this.centerActivePagination()
  }

  handleResize() {
    const wasMobile = this.isMobile
    this.isMobile = window.innerWidth <= 767

    // Only reinitialize if we're crossing the breakpoint
    if (wasMobile !== this.isMobile && !this.disableScroll && !this.mobileSlider) {
      if (this.isMobile) {
        this.destroySlider()
      } else {
        this.initBlazeSlider()
      }
    }
  }

  setupResizeObserver() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this && !this.isMobile && this.blazeInstance) {
          this.blazeInstance.refresh()
        }
      }
    })

    this.resizeObserver.observe(this)
  }

  setupThumbnailClicks() {
    // Thumbnail wrapper'ı bul ve sakla (parent n-product-gallery içinde)
    const productGallery = this.closest('n-product-gallery')
    this.thumbnailWrapper = productGallery ? productGallery.querySelector('.product-gallery__thumbnial') : null
    if (!this.thumbnailWrapper) return

    // Thumbnail'lere tıklama event'i ekle
    this.thumbnailWrapper.addEventListener('click', (e) => {
      const thumbnail = e.target.closest('.product-gallery__thumbnial-card')
      if (!thumbnail) return

      const slideIndex = parseInt(thumbnail.getAttribute('data-slide')) - 1

      // Slider'ı o slide'a götür
      if (this.blazeInstance && slideIndex >= 0) {
        this.blazeInstance.stopAutoplay()
        this.goToSlide(slideIndex)
      }
      this.userInteracted = true
    })

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.userInteracted = true
      })
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.userInteracted = true
      })
    }
  }

  // Belirli bir slide'a gitmek için custom metod
  goToSlide(targetIndex) {
    if (!this.blazeInstance) return

    const difference = targetIndex - this.currentSlideIndex

    if (difference === 0) return // Zaten o slide'dayız

    // Farkı hesaplayıp prev veya next kullan - tek seferde git
    const steps = Math.abs(difference)

    if (difference > 0) {
      // İleri git (next) - parametre olarak adım sayısını geç
      this.blazeInstance.next(steps)
    } else {
      // Geri git (prev) - parametre olarak adım sayısını geç
      this.blazeInstance.prev(steps)
    }
  }

  updateActiveThumbnail(slideIndex) {
    if (!this.thumbnailWrapper) return

    const thumbnails = this.thumbnailWrapper.querySelectorAll('.product-gallery__thumbnial-card')
    console.log('Slide Index:' + slideIndex)
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.classList.toggle('active', index === slideIndex)
    })

    // Aktif thumbnail'in görünür olmasını sağla
    const activeThumbnail = thumbnails[slideIndex]
    if (activeThumbnail) {
      activeThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      })
    }
  }

  setupPaginationScroll() {
    // Pagination container'ı bul
    this.paginationContainer = this.container.querySelector('.product-gallery__pagination')
    if (!this.paginationContainer) return

    // Önceki active button'u takip et
    this.previousActiveIndex = 0

    // Pagination button'larına click event'i ekle
    this.paginationContainer.addEventListener('click', (e) => {
      const button = e.target.closest('button')
      if (!button) return

      // Kısa bir gecikme ile scroll yap (BlazeSlider'ın active class'ı eklemesini bekle)
      setTimeout(() => {
        this.centerActivePagination()
      }, 50)
    })
  }

  centerActivePagination() {
    if (!this.paginationContainer) return

    const buttons = this.paginationContainer.querySelectorAll('button')
    const activeButton = this.paginationContainer.querySelector('button.active')
    if (!activeButton) return

    // Active button'un index'ini bul
    let currentActiveIndex = 0
    buttons.forEach((btn, index) => {
      if (btn === activeButton) {
        currentActiveIndex = index
      }
    })

    // Önceki index ile karşılaştır
    const indexDiff = currentActiveIndex - this.previousActiveIndex

    // Button genişliği + gap (2px)
    const buttonWidth = 24 // CSS'den gelen değer
    const gap = 2 // CSS'den gelen değer
    const scrollAmount = (buttonWidth + gap) * indexDiff

    // Sadece fark kadar scroll et
    if (scrollAmount !== 0) {
      this.paginationContainer.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      })
    }

    // Şimdiki index'i kaydet
    this.previousActiveIndex = currentActiveIndex
  }

}

if (!customElements.get('n-responsive-slider')) {
  customElements.define('n-responsive-slider', NResponsiveSlider)
}